// src/config.js

import classic350 from "../src/asset/bikes/Classic350.jpg";
import classic650 from "../src/asset/bikes/Classic-650.webp";
import guerrilla from "../src/asset/bikes/Guerrilla-450.jpg";
import shotgun from "../src/asset/bikes/Shotgun.png";
import himalayan from "../src/asset/bikes/Himalayan.png";
import himalayan440 from "../src/asset/bikes/Himalayan-440.jpg";
import bullet from "../src/asset/bikes/Bullet.png";
import meteor from "../src/asset/bikes/Meteor-350.jpg";
//import scram from "../src/asset/bikes/Scram-411.png";
import hunter from "../src/asset/bikes/Hunter.jpg";
import interceptor from "../src/asset/bikes/Interceptor.png";
import continental from "../src/asset/bikes/GT.jpg";
import supermeteor from "../src/asset/bikes/Super-Meteor650.png";
import interceptorbear from '../src/asset/bikes/Bear-650.png';
import goanclassic from '../src/asset/bikes/Goan350.png';
import scram440 from '../src/asset/bikes/Scram-440.png';
import bullet650 from '../src/asset/bikes/Bullet-650.jpg';

const motorcycles = [
   {
    name: "Classic 350",
    img: classic350,
    configureUrl: process.env.REACT_APP_CLASSIC_350_URL,
  },
   {
    name: "Himalayan 440",
    img: himalayan440,
    configureUrl: process.env.REACT_APP_HIMALAYAN_440_URL,
  },
  {
    name: "Bullet 650",
    img: bullet650,
    configureUrl: process.env.REACT_APP_BULLET_650_URL,
  },
  {
    name: "New Himalayan",
    img: himalayan,
    configureUrl: process.env.REACT_APP_HIMALAYAN_URL,
  },
  {
    name: "Meteor 350",
    img: meteor,
    configureUrl: process.env.REACT_APP_METEOR_350_URL,
  },
  {
    name: "Classic 650",
    img: classic650,
    configureUrl: process.env.REACT_APP_CLASSIC_650_URL,
  },
  {
    name: "Scram 440",
    img: scram440,
    configureUrl: process.env.REACT_APP_SCRAM_440_URL,
  },
  {
    name: "Goan Classic 350",
    img: goanclassic,
    configureUrl: process.env.REACT_APP_GOAN_CLASSIC_URL,
  },
  {
    name: "Guerrilla 450",
    img: guerrilla,
    configureUrl: process.env.REACT_APP_GUERRILLA_450_URL,
  },
  {
    name: "Shotgun 650",
    img: shotgun,
    configureUrl: process.env.REACT_APP_SHOTGUN_650_URL,
  },
  {
    name: "Bullet 350",
    img: bullet,
    configureUrl: process.env.REACT_APP_BULLET_350_URL,
  },
  {
    name: "Super Meteor 650",
    img: supermeteor,
    configureUrl: process.env.REACT_APP_SUPER_METEOR_650_URL,
  },
  {
    name: "Hunter 350",
    img: hunter,
    configureUrl: process.env.REACT_APP_HUNTER_350_URL,
  },
  {
    name: "Interceptor 650",
    img: interceptor,
    configureUrl: process.env.REACT_APP_INTERCEPTOR_650_URL,
  },
  {
    name: "Continental GT",
    img: continental,
    configureUrl: process.env.REACT_APP_CONTINENTAL_GT_URL,
  },
  {
    name: "Interceptor Bear 650",
    img: interceptorbear,
    configureUrl: process.env.REACT_APP_INTERCEPTOR_BEAR_650_URL,
  },
];

export default motorcycles;

export const URL = {
  TEST_RIDE: process.env.REACT_APP_TEST_RIDE_URL,
  MAKE_IT_YOURS: process.env.REACT_APP_MAKE_IT_YOURS_URL,
};